import { useEffect, useRef, useState } from 'react';

import styles from './MessageContent.module.css';
import { useScrollText } from '../../hooks/useScrollText';
import { useTicker } from './useTicker';

export const MessageContent = ({
  content,
  setDelay,
  msgId,
  contentContainerRef,
}) => {
  const contentRef = useRef();
  // const { animatedPositionX, scrollSpeed, scrollDelayStart } = useScrollText(
  //   contentRef,
  //   contentContainerRef,
  //   msgId,
  //   setDelay,
  // );

  const [lines, setLines] = useState([]);

  // useTicker({
  //   startDelay: scrollDelayStart,
  //   msgId,
  //   scrollSpeed,
  //   animatedPositionX,
  //   contentRef,
  // });

  useEffect(() => {
    const updateLines = () => {
      if (!contentRef.current) return;

      const container = contentRef.current;
      const containerWidth = container.clientWidth;

      console.log('containerWidth', containerWidth);

      const words = content.split(' ');
      const lines = [];
      let currentLine = '';
      let tempSpan = document.createElement('span');

      tempSpan.style.visibility = 'hidden';
      tempSpan.style.whiteSpace = 'nowrap';
      tempSpan.style.font = 'inherit';

      container.appendChild(tempSpan);

      // document.body.appendChild(tempSpan);

      words.forEach((word, index) => {
        const testLine = currentLine ? `${currentLine} ${word}` : word;
        tempSpan.textContent = testLine;

        if (tempSpan.offsetWidth > containerWidth && currentLine !== '') {
          lines.push(currentLine);
          currentLine = word;
        } else {
          currentLine = testLine;
        }

        if (index === words.length - 1) {
          lines.push(currentLine);
        }
      });

      container.removeChild(tempSpan);
      setLines(lines);
    };

    updateLines();

    const handleResize = () => {
      updateLines();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [content]);

  console.log('lines', lines);

  return (
    <div className={styles.content} ref={contentRef}>
      {content}
    </div>
  );
};
